<template>
  <ComponentCard title="Scholar says" icon="solar:user-speak-rounded-linear">
    <BlockField :model-value="attrs.text" placeholder="What the scholar said" :read-only="readOnly" input-class="font-display text-[15px] italic leading-relaxed text-[#1c4848]" @update:model-value="set({ text: $event })" />
    <div class="grid gap-2 sm:grid-cols-2">
      <BlockField :model-value="attrs.scholar" placeholder="Scholar" :read-only="readOnly" input-class="text-xs font-bold text-[#1c4848]" @update:model-value="set({ scholar: $event })" />
      <BlockField :model-value="attrs.source" placeholder="Book or fatwa" :read-only="readOnly" input-class="text-xs font-semibold text-[#a0833c]" @update:model-value="set({ source: $event })" />
    </div>
  </ComponentCard>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';

defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
</script>
